/*
 * Danish entry point.
 *
 * da/index.html loads this. The page body is assembled by app.ts; this
 * file only supplies the Danish dictionary and the href of the other
 * language's page for the toggle.
 */
import { da } from "./i18n/da";
import { mountPage } from "./app";

mountPage(da, "/");
